<mat-tree
  #myMatTree
  [dataSource]="dataSource"
  [treeControl]="treeControl"
  [trackBy]="trackByFn"
  class="example-tree bg-inherit px-[16px]"
>
  <!-- This is the tree node template for leaf nodes -->
  <mat-tree-node
    *matTreeNodeDef="let node"
    matTreeNodeToggle
    class="flex justify-between w-full, items center hover:cursor-pointer rounded-md !text-slate-400"
    (click)="onTagClick.emit(node)"
  >
    <div
      *ngIf="isVisible(node)"
      [ngClass]="getClassObject(node)"
      class="mat-tree-node rounded-md pr-2 py-2 max-w-full"
    >
      <div class="flex whitespace-nowrap justify-between w-full">
        <div class="!text-slate-400 shrink flex truncate mr-4">
          <tag-node-icon [node]="node" [tags]="detailedTags"></tag-node-icon>
          <span class="grow truncate text-ellipsis">{{
            node.fullPath.split("/").slice(-1)
          }}</span>
        </div>

        <tag-node-summary
          class="shrink-0 text-right"
          [node]="node"
          [tags]="detailedTags"
        ></tag-node-summary>
      </div>
    </div>
  </mat-tree-node>
  <!-- This is the tree node template for expandable nodes -->
  <mat-nested-tree-node
    *matTreeNodeDef="let node; when: hasChildAndVisible"
    class="!border-b-2 border-indigo-500 !text-slate-400"
  >
    <div
      class="mat-tree-node rounded-md pr-2 py-2"
      [ngClass]="getClassObject(node)"
      [ngClass]="{ 'bg-zinc-700': tag === node.fullPath }"
    >
      <span
        class="flex justify-between w-full items-center hover:cursor-pointer"
        (click)="onTagClick.emit(node)"
      >
        <!-- Name and icon -->
        <span class="flex">
          <!-- Icon -->

          <span>
            <tag-node-icon [node]="node" [tags]="detailedTags"></tag-node-icon>
          </span>

          <span class="!text-slate-400">{{
            node.fullPath.split("/").slice(-1)
          }}</span>
        </span>

        <!-- Numbers -->
        <tag-node-summary
          [node]="node"
          [tags]="detailedTags"
        ></tag-node-summary>
      </span>
    </div>
    <!-- There is inline padding applied to this div using styles.
            This padding value depends on the mat-icon-button width.  -->

    <div class="mat-tree-node-outlet-container show" role="group">
      <ng-container matTreeNodeOutlet></ng-container>
    </div>
  </mat-nested-tree-node>
</mat-tree>
